module.exports = __webpack_public_path__ + "img/user.f12813f6.svg";